module.exports = __webpack_public_path__ + "static/roseLeft-7c092fcd3a80d301b0cbae55abd7f057.png";